var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useState } from "react";
import { formattedDateWithHour } from "../../../utils/date";
import { FormAppointmentActionDTO } from "../resources/FormAppointmentActionDTO";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogActionType, getCatalogAppointmentStatus, } from "../../../store/catalog/actions";
import { executiveListGet, getAppointmentActionClearData, } from "../../../store/appointment/actions";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { appointmentActionPatch, appointmentActionPatchClearData, appointmentPost, appointmentPostClearData, getAppointmentAction, } from "../../../store/actions";
import { showErrorToast } from "../../../fnx/showError";
import { useTranslation } from "react-i18next";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { useQuotePrice } from "./useQuotePrice";
export var useAppointmentManager = function (appointmentId, setOpenModalAddAppointmentAction, setTriggerAddAppointmentAction, triggerAddAppointmentAction, showTabAppointmentManager, userId, setSeeToast, holidays, appointmentRows, quoteId, executiveUserId, setAppointmentRows, setAppointmentId, setExecutiveUserId, rolAsesorId, callQuoteOne, effectiveQuoteId, callAppointment) {
    var _a = useState([]), appointmentManagerRows = _a[0], setAppointmentManagerRows = _a[1];
    var handleAddAppointmetAction = useCallback(function () {
        setTriggerAddAppointmentAction(true);
        setOpenModalAddAppointmentAction(true);
    }, [setTriggerAddAppointmentAction, setOpenModalAddAppointmentAction]);
    var _b = useState(FormAppointmentActionDTO), formAppointmentActionProps = _b[0], setFormAppointmentActionProps = _b[1];
    var _c = useState(""), pendingActionType = _c[0], setPendingActionType = _c[1];
    var _d = useState(""), pendingPremium = _d[0], setPendingPremium = _d[1];
    var dispatch = useDispatch();
    var responseGetCatalogActionType = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogActionType: (_a = state.Catalog.responseGetCatalogActionType) === null || _a === void 0 ? void 0 : _a.data,
        });
    }).responseGetCatalogActionType;
    var responseGetCatalogAppointmentStatus = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogAppointmentStatus: (_a = state.Catalog.responseGetCatalogAppointmentStatus) === null || _a === void 0 ? void 0 : _a.data,
        });
    }).responseGetCatalogAppointmentStatus;
    var responseGetAppointmentAction = useSelector(function (state) {
        var _a;
        return ({
            responseGetAppointmentAction: (_a = state.Appointment.responseGetAppointmentAction) === null || _a === void 0 ? void 0 : _a.data,
        });
    }).responseGetAppointmentAction;
    var responseGetExecutiveList = useSelector(function (state) {
        var _a;
        return ({
            responseGetExecutiveList: (_a = state.Appointment.responseGetExecutiveList) === null || _a === void 0 ? void 0 : _a.data,
        });
    }).responseGetExecutiveList;
    var _e = useQuotePrice(setSeeToast, function () {
        if (effectiveQuoteId)
            callQuoteOne(effectiveQuoteId);
    }), updateQuotePrice = _e.updateQuotePrice, quotePriceLoading = _e.quotePriceLoading;
    var responseGetAppointmentAvailability = useSelector(function (state) {
        var _a;
        return ({
            responseGetAppointmentAvailability: (_a = state.Appointment.responseGetAppointmentAvailability) === null || _a === void 0 ? void 0 : _a.data,
        });
    }).responseGetAppointmentAvailability;
    useEffect(function () {
        if (triggerAddAppointmentAction) {
            dispatch(getCatalogActionType({
                enable: true,
                page: 1,
                limit: 20,
                type: "CATALOG_ACTION_TYPES",
            }));
            dispatch(getCatalogAppointmentStatus({
                enable: true,
                page: 1,
                limit: 20,
                type: "CATALOG_APPOINTMENT_STATUS",
            }));
            if (appointmentRows.length > 0) {
                setFormAppointmentActionProps(function (prev) { return (__assign(__assign({}, prev), { executiveId: executiveUserId })); });
            }
        }
    }, [triggerAddAppointmentAction]);
    useEffect(function () {
        if (rolAsesorId !== "" && triggerAddAppointmentAction) {
            dispatch(executiveListGet({
                roles: rolAsesorId,
            }));
        }
    }, [rolAsesorId, triggerAddAppointmentAction]);
    useEffect(function () {
        if (showTabAppointmentManager && appointmentId) {
            dispatch(getAppointmentAction({
                appointmentId: appointmentId,
            }));
        }
    }, [showTabAppointmentManager, appointmentId]);
    useEffect(function () {
        if (responseGetCatalogActionType) {
            var actionTypeList_1 = responseGetCatalogActionType.map(function (item) { return ({
                id: item.id,
                value: item.code,
                name: item.description,
            }); });
            if (appointmentRows.length === 0) {
                actionTypeList_1 = actionTypeList_1.filter(function (item) { return item.value === "AG"; });
            }
            else {
                actionTypeList_1 = actionTypeList_1.filter(function (item) { return item.value !== "AG"; });
            }
            setFormAppointmentActionProps(function (prev) { return (__assign(__assign({}, prev), { actionTypeList: actionTypeList_1 })); });
        }
    }, [responseGetCatalogActionType, appointmentRows]);
    useEffect(function () {
        if (responseGetCatalogAppointmentStatus) {
            var AppointmentStatusList = responseGetCatalogAppointmentStatus.map(function (item) { return ({
                id: item.id,
                value: item.code,
                name: item.description,
            }); });
            var declineCodeList_1 = ["NI", "OS", "NMG", "DWS"];
            var followUpCodeList_1 = ["A", "PD", "CP", "RW"];
            var statusListDecline_1 = AppointmentStatusList.filter(function (item) {
                return declineCodeList_1.includes(item.value);
            });
            var statusListFollowUp_1 = AppointmentStatusList.filter(function (item) {
                return followUpCodeList_1.includes(item.value);
            });
            setFormAppointmentActionProps(function (prev) { return (__assign(__assign({}, prev), { statusListDecline: statusListDecline_1, statusListFollowUp: statusListFollowUp_1 })); });
        }
    }, [responseGetCatalogAppointmentStatus]);
    useEffect(function () {
        if (responseGetExecutiveList) {
            var executiveList_1 = responseGetExecutiveList.map(function (item) { return ({
                id: item.id,
                value: item.id,
                name: item.name,
            }); });
            setFormAppointmentActionProps(function (prev) { return (__assign(__assign({}, prev), { executiveList: executiveList_1 })); });
        }
    }, [responseGetExecutiveList]);
    useEffect(function () {
        if (responseGetAppointmentAction) {
            var appointmentActions = responseGetAppointmentAction.map(function (item) {
                var formattedDate = formattedDateWithHour(item.date);
                var formattedAppointmentDate = item.appointmentDate ? formattedDateWithHour(item.appointmentDate) : "";
                var formattedPremium = item.premium ? Number(item.premium).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) : "";
                return {
                    id: item.id,
                    date: formattedDate,
                    action: item.actionType,
                    status: item.status,
                    comment: item.comment,
                    newAppointmentDate: formattedAppointmentDate,
                    approvedPremium: formattedPremium,
                };
            });
            setAppointmentManagerRows(appointmentActions);
            dispatch(getAppointmentActionClearData());
        }
    }, [responseGetAppointmentAction]);
    var handleSubmitAppointmentAction = useCallback(function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        setPendingActionType((_a = data.actionType) !== null && _a !== void 0 ? _a : "");
        setPendingPremium((_b = data.approvedPremium) !== null && _b !== void 0 ? _b : "");
        // El backend espera el nombre largo (description), no el código.
        // Las listas del catálogo guardan { value: code, name: description },
        // por eso traducimos antes de mandar.
        var actionItem = (_c = formAppointmentActionProps.actionTypeList) === null || _c === void 0 ? void 0 : _c.find(function (i) { return i.value === data.actionType; });
        if ((actionItem === null || actionItem === void 0 ? void 0 : actionItem.value) !== "AG") {
            var statusItem = __spreadArray(__spreadArray([], ((_d = formAppointmentActionProps.statusListFollowUp) !== null && _d !== void 0 ? _d : []), true), ((_e = formAppointmentActionProps.statusListDecline) !== null && _e !== void 0 ? _e : []), true).find(function (i) { return i.value === data.statusType; });
            // El form devuelve approvedPremium como string ("4000"); el backend
            // lo necesita numérico. Si está vacío mandamos null (es como lo
            // representa el response del GET de appointments).
            var rawPremium = data.approvedPremium;
            var premium = null;
            if (rawPremium !== "" && rawPremium != null) {
                var parsed = Number(rawPremium.replace(/,/g, ""));
                premium = Number.isNaN(parsed) ? null : parsed;
            }
            var payload = {
                userId: userId,
                action: (_f = actionItem === null || actionItem === void 0 ? void 0 : actionItem.name) !== null && _f !== void 0 ? _f : data.actionType,
                status: (_h = (_g = statusItem === null || statusItem === void 0 ? void 0 : statusItem.name) !== null && _g !== void 0 ? _g : data.statusType) !== null && _h !== void 0 ? _h : "",
                comment: (_j = data.comment) !== null && _j !== void 0 ? _j : "",
                premium: premium,
                rescheduleDate: (_k = data.newAppointmentDate) !== null && _k !== void 0 ? _k : "",
                executiveUserId: data.executiveId,
            };
            dispatch(appointmentActionPatch({ data: payload }, appointmentId));
        }
        else {
            var payload = {
                comment: (_l = data.comment) !== null && _l !== void 0 ? _l : "",
                appointmentDate: (_m = data.newAppointmentDate) !== null && _m !== void 0 ? _m : "",
                executiveUserId: data.executiveId,
                quoteId: quoteId,
            };
            dispatch(appointmentPost({ data: payload }));
        }
    }, [formAppointmentActionProps, userId, appointmentId, quoteId]);
    var _f = useSelector(function (state) {
        var _a;
        return ({
            responseAppointmentActionPatch: (_a = state.Appointment.responseAppointmentActionPatch) === null || _a === void 0 ? void 0 : _a.data,
            loadingAppointmentActionPatch: state.Appointment.loadingAppointmentActionPatch,
            errorAppointmentActionPatch: state.Appointment.errorAppointmentActionPatch,
        });
    }), responseAppointmentActionPatch = _f.responseAppointmentActionPatch, loadingAppointmentActionPatch = _f.loadingAppointmentActionPatch, errorAppointmentActionPatch = _f.errorAppointmentActionPatch;
    useEffect(function () {
        if (responseAppointmentActionPatch) {
            var item = responseAppointmentActionPatch;
            var formattedDate = formattedDateWithHour(item.createdAt);
            var formattedAppointmentDate = item.appointmentDate ? formattedDateWithHour(item.appointmentDate) : "";
            var formattedPremium = item.premium ? Number(item.premium).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }) : "";
            var newAppointmentAction_1 = {
                id: item.id,
                date: formattedDate,
                action: item.actionType,
                status: item.status,
                comment: item.comment,
                newAppointmentDate: formattedAppointmentDate,
                approvedPremium: formattedPremium,
            };
            setAppointmentManagerRows(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newAppointmentAction_1], false); });
            showToastSuccessMessage("Gestión agregada con éxito.", typeAlert.success, setSeeToast);
            dispatch(appointmentActionPatchClearData());
            setOpenModalAddAppointmentAction(false);
            callAppointment(effectiveQuoteId);
            if (pendingActionType === "A" && pendingPremium && effectiveQuoteId) {
                var cleanPremium = parseFloat(pendingPremium.replace(/,/g, "")).toFixed(2);
                updateQuotePrice(effectiveQuoteId, cleanPremium);
            }
            else if (effectiveQuoteId) {
                callQuoteOne(effectiveQuoteId);
            }
            setPendingActionType("");
            setPendingPremium("");
        }
    }, [responseAppointmentActionPatch, pendingPremium, pendingActionType]);
    var _g = useSelector(function (state) {
        var _a;
        return ({
            responseAppointmentPost: (_a = state.Appointment.responseAppointmentPost) === null || _a === void 0 ? void 0 : _a.data,
            loadingAppointmentPost: state.Appointment.loadingAppointmentPost,
            errorAppointmentPost: state.Appointment.errorAppointmentPost,
        });
    }), responseAppointmentPost = _g.responseAppointmentPost, loadingAppointmentPost = _g.loadingAppointmentPost, errorAppointmentPost = _g.errorAppointmentPost;
    useEffect(function () {
        var _a, _b, _c;
        if (responseAppointmentPost) {
            var item = responseAppointmentPost;
            var formattedDate = formattedDateWithHour(item.appointmentDate);
            var formattedAppointmentDate = item.appointmentDate ? formattedDateWithHour(item.appointmentDate) : "";
            var formattedPremium = item.premium ? Number(item.premium).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }) : "";
            var newAppointmentAction_2 = {
                id: item.id,
                date: formattedDate,
                action: item.actionType ? item.actionType : "Agendar",
                status: item.status,
                comment: item.comment,
                newAppointmentDate: formattedAppointmentDate,
                approvedPremium: formattedPremium,
            };
            setAppointmentManagerRows(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newAppointmentAction_2], false); });
            var appointment = {
                id: responseAppointmentPost.id,
                appointmentDate: formattedDate,
                status: (_a = responseAppointmentPost.status) !== null && _a !== void 0 ? _a : "Agendada",
                comment: responseAppointmentPost.comment,
                officer: (_b = responseAppointmentPost.executiveName) !== null && _b !== void 0 ? _b : "",
                executiveUserId: responseAppointmentPost.executiveUserId,
            };
            setAppointmentId(appointment.id);
            setExecutiveUserId((_c = responseAppointmentPost.executiveUserId) !== null && _c !== void 0 ? _c : "");
            setAppointmentRows([appointment]);
            showToastSuccessMessage("Cita agendada con éxito.", typeAlert.success, setSeeToast);
            dispatch(appointmentPostClearData());
            setOpenModalAddAppointmentAction(false);
            if (effectiveQuoteId)
                callQuoteOne(effectiveQuoteId);
        }
    }, [responseAppointmentPost]);
    var t = useTranslation().t;
    useEffect(function () {
        if (errorAppointmentActionPatch) {
            showErrorToast(errorAppointmentActionPatch, setSeeToast, t, true);
            dispatch(appointmentActionPatchClearData());
            setOpenModalAddAppointmentAction(false);
        }
    }, [errorAppointmentActionPatch]);
    useEffect(function () {
        if (errorAppointmentPost) {
            showErrorToast(errorAppointmentPost, setSeeToast, t, true);
            dispatch(appointmentPostClearData());
        }
    }, [errorAppointmentPost]);
    useEffect(function () {
        if (holidays.length > 0) {
            setFormAppointmentActionProps(function (prev) { return (__assign(__assign({}, prev), { appointmentDateProps: __assign(__assign({}, prev.appointmentDateProps), { holidays: holidays }) })); });
        }
    }, [holidays]);
    return {
        appointmentManagerRows: appointmentManagerRows,
        handleAddAppointmetAction: handleAddAppointmetAction,
        handleSubmitAppointmentAction: handleSubmitAppointmentAction,
        formAppointmentActionProps: formAppointmentActionProps,
        loadingAppointmentActionPatch: loadingAppointmentActionPatch,
        loadingAppointmentPost: loadingAppointmentPost,
        quotePriceLoading: quotePriceLoading,
    };
};
